<template>
  <span class="text-left">
    <ed-button button-class="btn btn-actionbar"
               style="margin-bottom: 10px;"
               @click="showModal(showReject)"
               :ids="ids"
               :disabled="disabled"
               v-tooltip="tooltip">
      Decline
    </ed-button>
    <ed-modal title="Decline Envelope" :show="showReject" @close="closeModal" @confirm='approveOrReject' primary-button="Decline" primaryButtonClass="btn btn-danger" :loading="isRejecting">
      <div slot="body" class='reject-envelope-overlay'>
        <p class="small">Provide a reason for declining the envelope.</p>
        <label>Reason</label>
        <ed-input type='text' v-model='rejectReason' @input="(value) => rejectReason = value" :disabled="isRejecting" />
      </div>
    </ed-modal>
  </span>
</template>

<script>
export default {
  data() {
    return {
      rejectReason: '',
      showReject: false,
      isRejecting: false
    }
  },
  created() {
  },
  props: {
    ids: null,
    disabled: false,
    tooltip: '',
    selectedRows: [],
    envelope: Object
  },
  methods: {
    async approveOrReject() {
      if (this.isRejecting) return
      this.isRejecting = true
      try {
        let envelopesData = []
        if (this.selectedRows) {
          envelopesData = this.selectedRows.map(row => {
            return { Id: row.data.Id, RejectReason: this.rejectReason }
          })
        } else if (this.envelope) {
          envelopesData.push({ Id: this.envelope.Id, RejectReason: this.rejectReason })
        }

        if (envelopesData.length === 0) {
          throw new Error('No data available to approve or reject.')
        }

        let payload = {
          envelopesData: envelopesData
        }

        const response = await this.api.post(this.api.$.evedpaycard.approveOrRejectEnvelope, payload)

        if (!response.data) {
          throw new Error('Error during the request')
        } else {
          this.showReject = false
          this.rejectReason = ''
          this.$emit('success')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isRejecting = false
      }
    },

    closeModal() {
      if (this.isRejecting) return
      this.showReject = false
      this.rejectReason = ''
    },

    showModal(showReject) {
      this.showReject = !showReject
    }
  }
}
</script>

<style lang='scss' scoped>
  .reject-envelope-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-envelopes/RejectEnvelope.vue